import { DraftError, DraftState } from '@/types';
import { withoutHistory } from '@/components/draft/draftState/history/withoutHistory';
import { setValidationErrorFlag } from './helper/setValidationErrorFlag';

export const setValidationAction = (newErrors: Record<number, DraftError>) =>
  withoutHistory((draft: DraftState) => {
    Object.entries(newErrors).forEach(([cidKey, errorObject]) => {
      const cid = Number(cidKey);

      if (!draft.validation.errors[cid]) {
        draft.validation.errors[cid] = {};
      }

      const currentErrors = { ...draft.validation.errors[cid] };

      (Object.keys(errorObject) as (keyof DraftError)[]).forEach((errorKey) => {
        const errorState = errorObject[errorKey];
        if (errorState) {
          if (errorState !== currentErrors[errorKey]) {
            // @ts-ignore
            draft.validation.errors[cid][errorKey] = errorState;
          }
        } else if (currentErrors[errorKey]) {
          delete draft.validation.errors[cid][errorKey];
        }
      });
    });

    setValidationErrorFlag(draft);
  });
